import { NavigationMode } from '@app/common/navigation-mode.';
import { Environment } from '@environments/interface.environment';
import { NewsModeFeaturedNews, NewsModePersonalNews } from '@app/common/news-mode';
import { HideNewsComments } from '@app/common/hide-news-comments';
import { HideNewsLikes } from '@app/common/hide-news-likes';
import { ManagedProperties } from '@app/common/managed-property-config';
import { TrendingResult } from '@app/common/trending-result';
import { DefaultProtectedResourceScopesMap } from '@app/common/msal-angular-configuration';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: Environment = {
  production: true,
  name: 'prod',
  tenantHostUrl: 'https://imgroupltd.sharepoint.com',
  coreWorkplaceSiteUrl: 'https://imgroupltd.sharepoint.com/sites/workplace',
  msalConfig: {
    tenant: 'imgroupltd.onmicrosoft.com',
    auth: {
      clientId: '708a7372-9054-4364-91dc-9c4ea18aab07',
      authority: 'https://login.microsoftonline.com/imgroupltd.onmicrosoft.com',
    },
    protectedResourceScopeMap: [
      ...DefaultProtectedResourceScopesMap,
      [`/api/`, [`708a7372-9054-4364-91dc-9c4ea18aab07/.default`]],
      ['https://imgroupltd.sharepoint.com', ['https://imgroupltd.sharepoint.com/.default']],
    ]
  },
  featureSettings: {
    navigationMode: NavigationMode.HubSite,
    newsModeFeaturedNews: NewsModeFeaturedNews.GraphFromNewsCenterSite,
    newsModePersonalNews: NewsModePersonalNews.GraphFromNewsCenterSiteAndSearchFromFollowedSites,
    trendingResult: TrendingResult.Modern,
    newsArchiveLink: 'https://imgroupltd.sharepoint.com/sites/workplace',
    sharePointNewsCenterUrl: 'https://imgroupltd.sharepoint.com/sites/workplace',
    hideNewsComments: HideNewsComments.HideIfNoComments,
    hideNewsLikes: HideNewsLikes.HideIfNoLikes,
    managedPropertyConfig: ManagedProperties.DefaultConfig,
    redirectToTeamsByDefault: true,
    myColleagueRootTerm: '00000000-0000-0000-0000-000000000000',
    showBirthdayCalendar: true,
    showRestaurantMenus: true,
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
